/**
 * Angular bootstrapping
 */
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

/**
 * App Module
 * our top level module that holds all of our components
 */
import { AppModule } from './modules/app';
import * as Plyr from 'plyr/dist/plyr.js';
import * as RangeTouch from 'rangetouch/dist/rangetouch.js'
import './libs/audio-video-wrapper/video-player.js';
import './libs/audio-video-wrapper/audio-player.js';

import * as interact from 'interactjs/dist/interact.js';


window['Plyr'] = Plyr;
window['RangeTouch'] = RangeTouch;
window['interact'] = interact;

/**
 *  Import Raven-js for Sentry
 */
import Raven from 'raven-js';

/**
 * set up raven for error logging
 */
function initRavenJS(){
  if(SENTRY_DSN && SENTRY_ENABLED){
    //set default settings
    let config = {
      "allowDuplicates" : true,
      tags: {app_name: APP_NAME}
    }
    
    // set Sentry Environment
    config['environment']  = APP_ENV.toUpperCase();

    /*
    * Setup additional Sentry configuration here
    * see here: https://docs.sentry.io/clients/javascript/config/
    */
    if(APP_ENV != 'local') Raven.config(SENTRY_DSN, config).install();
  }
  
}

/**
 * Bootstrap our Angular app with a top level NgModule
 */
export function main(): Promise<any> {
  initRavenJS();
  return platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
}

/**
 * Needed for hmr
 * in prod this is replace for document ready
 */
switch (document.readyState) {
  case 'loading':
    document.addEventListener('DOMContentLoaded', _domReadyHandler, false);
    break;
  case 'interactive':
  case 'complete':
  default:
    main();
}

function _domReadyHandler() {
 document.removeEventListener('DOMContentLoaded', _domReadyHandler, false);
 main();
}
